import { Country } from '../types';
import { VISITED_COUNTRIES_URL } from '../constants/api';

// 訪問済み国を格納する配列
export let visitedCountries: Country[] = [];

// データがロード済みかどうかのフラグ
let isDataLoaded = false;

// タグ名から国情報を取得する関数
export const getCountryByTagName = (tagName: string): Country | undefined => {
  return visitedCountries.find(country => 
    country.nameJa === tagName || 
    country.name === tagName
  );
};

// CSVファイルから訪問済み国情報を読み込む関数
export const fetchCountriesFromCSV = async (): Promise<Country[]> => {
  // すでにデータがロード済みの場合は、キャッシュされたデータを返す
  if (isDataLoaded && visitedCountries.length > 0) {
    return visitedCountries;
  }

  try {
    const response = await fetch(VISITED_COUNTRIES_URL);
    
    if (!response.ok) {
      throw new Error(`訪問済み国データの取得に失敗しました (${response.status})`);
    }
    
    const csvText = await response.text();
    const lines = csvText.split('\n').filter(line => line.trim() !== '');
    
    // CSVパース処理が実装されていれば、ここでパースする
    const countries: Country[] = [];
    
    // ヘッダー行をスキップして処理（インデックス1から開始）
    for (let i = 1; i < lines.length; i++) {
      const columns = lines[i].split(',');
      countries.push({
        id: columns[0].trim(),
        nameJa: columns[1].trim(),
        name: columns[2].trim(),
        region: columns[3].trim(),
        status: columns[4].trim()
      });
    }
    
    // 結果を保存
    visitedCountries = countries;
    isDataLoaded = true;
    
    return countries;
  } catch (error) {
    console.error('訪問国データの読み込みエラー:', error);
    return [];
  }
};

// アプリケーション起動時にデータを事前に読み込む
fetchCountriesFromCSV().catch(error => {
  console.error('初期データ読み込みエラー:', error);
});